<div class="modal-header">
  <h4 class="modal-title pull-left">Atualizar Cadastro</h4>
</div>

<div class="modal-body scroll">
  <p class="texto">Mantenha seus dados atualizados para facilitar o contato com você.</p>

  <form class="row" [formGroup]="form">
    <div class="col-md-12 col-lg-12 col-sm-12 form-group">
      <label class="label-form">NOME</label>
      <div class="form-validation">
        <input type="text" formControlName="name" class="form-control"
          [ngClass]="{ 'is-invalid': submitted && f['name'].errors }" maxlength="50"
        />
        <div class="invalid-feedback" *ngIf="submitted && f['name'].errors">
          <div *ngIf="f['name'].errors['required']">Preenchimento obrigatório</div>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-lg-6 col-sm-12 form-group">
      <label class="label-form">TELEFONE</label>
      <div class="form-validation">
        <input type="text" formControlName="telephone" class="form-control" mask="(00)0000-0000||(00)00000-0000"
          [ngClass]="{ 'is-invalid': submitted && f['telephone'].errors }"
        />
        <div class="invalid-feedback" *ngIf="submitted && f['telephone'].errors">
          <div *ngIf="f['telephone'].errors['required']">Preenchimento obrigatório</div>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-lg-6 col-sm-12 form-group">
      <label class="label-form">E-MAIL</label>
      <div class="form-validation">
        <input type="text" formControlName="email" class="form-control"
          [ngClass]="{ 'is-invalid': submitted && f['email'].errors }" maxlength="50"
        />
        <div class="invalid-feedback" *ngIf="submitted && f['email'].errors">
          <div *ngIf="f['email'].errors['required']">Preenchimento obrigatório</div>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-lg-6 col-sm-12 form-group">
      <label class="label-form">CARGO</label>
      <div class="form-validation">
        <select formControlName="cargo" [ngClass]="{ 'is-invalid': submitted && f['cargo'].errors }" (change)="verificaCargo($event)">
          <ng-container *ngFor="let cargo of cargos">
            <option [value]="cargo.cargo">{{cargo.cargo}}</option>
          </ng-container>
        </select>
        <div class="invalid-feedback" *ngIf="submitted && f['position'].errors">
          <div *ngIf="f['position'].errors['required']">Preenchimento obrigatório</div>
        </div>

        <input type="text" formControlName="position" class="form-control mt-2" *ngIf="form.get('cargo').value === 'Outro(a)'"
          [ngClass]="{ 'is-invalid': submitted && f['position'].errors }"
        />
        <div class="invalid-feedback" *ngIf="submitted && f['position'].errors">
          <div *ngIf="f['position'].errors['required']">Preenchimento obrigatório</div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-6 col-sm-12 form-group">
      <label class="label-form">WHATSAPP</label>
      <div class="form-validation">
        <input type="text" formControlName="cellphone" class="form-control" mask="(00)0000-0000||(00)00000-0000"
          [ngClass]="{ 'is-invalid': submitted && f['cellphone'].errors }"
        />
        <div class="invalid-feedback" *ngIf="submitted && f['cellphone'].errors">
          <div *ngIf="f['cellphone'].errors['required']">Preenchimento obrigatório</div>
        </div>
      </div>
    </div>
  </form>

  <p class="texto">Declaro que os dados são verdadeiros e meu login é único e intransferível.</p>
</div>

<div class="modal-footer">
  <button class="botao-ok" (click)="onSubmit()">Salvar Alterações</button>
</div>
